import { Injectable } from '@angular/core';
import { AuthUser } from './auth-user';
import { Router } from '@angular/router';
import { CLEANUP } from '@angular/core/src/render3/interfaces/view';

const TOKEN_KEY = 'AuthToken';
const LASTACCESS = 'LastAccess';
const LOGIN_TIME = 'LoggedIn';

@Injectable()
export class TokenService {

    authUser: AuthUser;

    constructor(
        private router: Router
    ) { }

    /**
     * verify if there is any token set in local storage and extracts the user. 
     * If no token is set, all data from local storage will be removed 
     */
    private extractUserFromToken() {
        if (this.hasToken()) {
            const authToken = this.getToken();
            const claim = authToken.split('.')[1];
            this.authUser = AuthUser.fromJson(atob(claim));
        } else {
            this.cleanUp();
        }
    }

    /**
     * verify if we have a token and parse the user from the token
     */
    whoAmI(): AuthUser {
        this.extractUserFromToken();
        return this.authUser;
    }

    /**
     * verify if we have an valid token and the token is not expired
     */
    isUserValid(): boolean {
        const valid = this.hasToken() && !this.whoAmI().isTokenExpired();
        if (!valid) {
            this.cleanUp();
        }
        return valid;
    }

    /**
     * cleanup the local storage, removing all values which are set
     */
    cleanUp() {
        // localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(LASTACCESS);
        localStorage.clear()
        delete (this.authUser);
    }

    signOut() {
        this.cleanUp();
    }

    saveToken(token: string) {
        this.cleanUp();
        localStorage.setItem(TOKEN_KEY, token);
        this.setLoginTime();
        this.setAccess();
        this.authUser = this.whoAmI();
    }

    /**
     * return the authtoken stored in the local storage
     */
    getToken(): string {
        const token = localStorage.getItem(TOKEN_KEY);
        return token;
    }
    /**
     * verify if there is any authtoken stored in local stoage
     */
    hasToken(): boolean {
        return (this.getToken() != undefined);
    }

    /**
     * store the current time in local storage
     */
    setAccess() {
        const now = Math.round(new Date().getTime() / 1000);
        localStorage.setItem(LASTACCESS, now.toString());
    }
    setLoginTime() {
        const now = Math.round(new Date().getTime() / 1000);
        localStorage.setItem(LOGIN_TIME, now.toString());
    }

    /**
     * read the last accessed time stored in local storage
     */
    lastAccess(): number {
        return +localStorage.getItem(LASTACCESS);
    }

    /**
     * 
     * @param minutes verify if thre auth
     */
    expiresWithin(minutes = 10): boolean {
        const now = new Date().getTime() / 1000;
        const treshold = minutes * 60;
        return this.authUser.exp - now < treshold;
    }

}
